import React, { useState, useEffect } from 'react';
import {
  createNewParser,
  useOnOffChainFormContext,
} from './OnOffChainFormContext';
import { WalletBlockchain } from 'src/services/gql/generated';
import useFrequencyByUnit, {
  covertCronToFrequencyAndUnit,
} from 'src/hooks/useFrequencyByUnit';
import CronInput from './CronInput';
import { Typography } from '@mui/material';

const CreateOffChainTopicStep2: React.FC = () => {
  const { frequency, unit, setFrequency, setUnit, cronExecutionInterval } =
    useFrequencyByUnit();
  const [cronExecution, setCronExecution] = useState<any>(null);

  const {
    selectedParser,
    parserName,
    setIsSaveTopicButtonEnabled,
    setFusionSourceData,
  } = useOnOffChainFormContext();

  // It'll keep the local form state in sync with the Form-Context-Provider.
  useEffect(() => {
    const isCreateNewParserSelected = selectedParser.id === createNewParser;

    const isInvalidInput = isCreateNewParserSelected && (!frequency || !parserName);
    const isExistingParser = selectedParser.id !== createNewParser;

    if (isInvalidInput) {
      setIsSaveTopicButtonEnabled(false);
      return;
    }

    let filter = { CronExecutionInterval: cronExecutionInterval };
    if (isExistingParser) filter = JSON.parse(selectedParser?.filter || '{}');

    const fusionSourceData = {
      name: parserName,
      blockchainType: WalletBlockchain.OFF_CHAIN,
      filter: JSON.stringify(filter),
    };

    setFusionSourceData(fusionSourceData);
    setIsSaveTopicButtonEnabled(true);
  }, [
    cronExecutionInterval,
    frequency,
    parserName,
    selectedParser,
    setFusionSourceData,
    setIsSaveTopicButtonEnabled,
  ]);

  useEffect(() => {
    setCronExecution(
      selectedParser?.id !== createNewParser
        ? JSON.parse(selectedParser?.filter)
        : null,
    );
  }, [selectedParser, createNewParser]);

  const cronIntervalFormatter = (cron: string) => {
    if (cron) {
      const { unit, frequency } = covertCronToFrequencyAndUnit(
        cronExecution?.CronExecutionInterval,
      );
      //TODO: Add refetch to the source state.
      if (frequency === 0 && unit === 'Days') {
        return <span style={{ textTransform: 'lowercase' }}></span>;
      }
      return (
        <>
          {frequency} <span style={{ textTransform: 'lowercase' }}>{unit}</span>
        </>
      );
    }
  };

  return (
    <>
      {selectedParser?.id !== createNewParser ? (
        <Typography
          sx={{
            fontFamily: 'Rota',
            fontWeight: 700,
            fontSize: '16px',
            color: '#262949',
          }}
        >
          The selected parser runs every{' '}
          {cronIntervalFormatter(cronExecution?.CronExecutionInterval)}. You can
          edit the parser from a topic view.
        </Typography>
      ) : (
        <CronInput
          unit={unit}
          setUnit={setUnit}
          frequency={frequency}
          setFrequency={setFrequency}
        />
      )}
    </>
  );
};

export default CreateOffChainTopicStep2;
